import React from 'react'
import { t } from 'ttag'

import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'

import styles from './CandidatesTable.module.scss'
import jobStyles from '../JobDetails.module.scss'
import { getFiltersConfigs } from '../model'
import { getIsFilteredResults, getFilterInitState } from '../../helpers'

export const CandidatesTable = ({
  active,
  headers,
  isAllRowsSelected,
  isFetching,
  isSomeRowsSelected,
  currentPage,
  pageCount,
  perPage,
  toggleAllRowsSelectedHandler,
  handlePage,
  handlePageSize,
  placeholder,
  filter,
  setFilter,
  children,
}) => {
  const resultsPlaceholder = React.useMemo(() => {
    const isFilteredResults = getIsFilteredResults(getFiltersConfigs(), filter)

    if (isFilteredResults) {
      const initFilter = getFilterInitState()
      const handleReset = () =>
        setFilter(
          getFiltersConfigs().reduce((acc, conf) => initFilter(acc, conf), {}),
        )

      return {
        title: t`There are no candidates matching the selected filters`,
        text: (
          <div
            className={styles.resetButton}
            onClick={handleReset}
          >{t`reset filters`}</div>
        ),
      }
    }

    return placeholder
  }, [filter])

  return (
    <>
      <Table className={styles.table}>
        <Table.Head>
          <Table.Row
            type="head"
            onChange={toggleAllRowsSelectedHandler}
            isChecked={isAllRowsSelected}
            isIndeterminate={isSomeRowsSelected}
            hasCheckbox={!isFetching}
            isDisabled={!active}
          >
            {headers.map(
              ({ columnDef, getToggleSortingHandler, getIsSorted }) => {
                const { accessorKey, header, alignLeft } = columnDef

                return (
                  <HeaderCell
                    key={header}
                    sortType={getIsSorted()}
                    text={header}
                    onClick={getToggleSortingHandler()}
                    hasSorting={accessorKey}
                    className={alignLeft && jobStyles.alignLeft}
                  />
                )
              },
            )}
          </Table.Row>
        </Table.Head>
        <Table.Body placeholder={resultsPlaceholder} isLoaded={!isFetching}>
          {children}
        </Table.Body>
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
